module.exports = __webpack_public_path__ + "static/img/nav5.5cdf88a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav5.jpg
// module id = AvSG
// module chunks = 62